export enum FLOWS {
  NONE,
  PAY_WITH_BLUETAPE_CREDIT_FLOW,
  PAY_WITH_BANK_ACCOUNT_FLOW,
  PAY_WITH_CARD_FLOW,
  ADD_NEW_PROJECT_FLOW,
  ADD_NEW_BANK_ACOUNT,
  CONNECT_NEW_BANK_ACCOUNT,
  ADD_NEW_CREDIT_CARD,
  ADD_NEW_PAYMENT_METHOD,
  NOT_ENOUGH_PERMISSIONS,
}

export enum GUEST_FLOWS {
  NONE,
  ADD_NEW_CREDIT_CARD,
  PAYMENT_ERROR,
  PAYMENT_SUCCESS,
}

export enum GUEST_MOBILE_FLOWS {
  CONTACT_INFO,
  ADD_NEW_PAYMENT_METHOD,
  ADD_NEW_CREDIT_CARD,
  PAY_INVOICE,
}
